<p-dialog
  *ngIf="viewModel$ | async as viewModel"
  header="Apply Discount"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [breakpoints]="{ '992px': '62vw', '510px': '93vw' }"
  [visible]="viewModel.visible"
  [dismissableMask]="true"
  (visibleChange)="store.dispatch(actions.closeButtonClicked())"
>
  <div>
    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-4">
        <label>Discount</label>
        <br />
        <p-dropdown
          placeholder="Selected Discount"
          [options]="viewModel.availableDiscounts"
          appendTo="body"
          [ngModel]="viewModel.discountId"
          (onChange)="store.dispatch(actions.discountSelected({
            discountId: $event.value,
            amount: getDiscountAmountById($event.value, viewModel.availableDiscounts)
          }))"
          optionValue="id"
        >
          <ng-template
            pTemplate="item"
            let-discount
          >
            {{ discount.name }} ({{ discount.code }})
          </ng-template>
          <ng-template
            pTemplate="selectedItem"
            let-discount
          >
            {{ discount.name }} ({{ discount.code }})
          </ng-template>
        </p-dropdown>
      </div>
      <div
        class="p-col-12 p-md-4"
      >
        <label>Amount </label>
        <br />
        <p-inputNumber
          [ngModel]="viewModel.amount.value"
          [min]="viewModel.amount.min"
          [max]="viewModel.amount.max"
          [disabled]="viewModel.amount.disabled"
          (onInput)="store.dispatch(actions.amountInputChanged({ amount: $event.value }))"
          #amountModel="ngModel"
          placeholder="Enter amount"
          [showButtons]="true"
          [step]="viewModel.selectedDiscount?.discountType === 'percentage' ? 1 : 0.25"
          [mode]="
            viewModel.selectedDiscount?.discountType === 'percentage'
              ? 'decimal'
              : 'currency'
          "
          [currency]="viewModel.currency"
          [minFractionDigits]="
            viewModel.selectedDiscount?.discountType === 'amount' ? 1 : 0
          "
          [suffix]="
            viewModel.selectedDiscount?.discountType === 'percentage' ? '%' : undefined
          "
        ></p-inputNumber>
        <small *ngIf="viewModel.selectedDiscount">
          Range:
          {{
          viewModel.selectedDiscount?.customAmountRange
          | discountCustomAmountRange
          : viewModel.selectedDiscount?.discountType
          : (viewModel.currency)
          }}
        </small>
        <app-validation-messages [control]="amountModel.control"></app-validation-messages>
      </div>
      <div class="p-col-12 p-md-4">
        <label>Select Event</label>
        <app-job-event-select
          [ngModel]="viewModel.eventIds"
          (ngModelChange)="store.dispatch(actions.eventSelectionChanged({ eventIds: $event }))"
          [appArrayMinLength]="1"
        ></app-job-event-select>
        <br />
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      (click)="store.dispatch(actions.cancelButtonClicked())"
      icon="pi pi-times"
      label="Cancel"
    ></button>
    <button
      pButton
      (click)="store.dispatch(actions.newSingleUseButtonClicked())"
      icon="pi pi-plus"
      label="New Single Use"
    ></button>
    <button
      pButton
      [disabled]="viewModel.disabled"
      (click)="store.dispatch(actions.applyChangesButtonClicked({ amountTouched: amountModel.touched }))"
      icon="pi pi-check"
      label="Apply Changes"
      class="p-button-success"
    ></button>
  </ng-template>
</p-dialog>

<app-job-mutate-discount>
</app-job-mutate-discount>
